import styled from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledPatientEntitlementsDocumentTabsContent = styled(StyledFlex)`
   position: relative;
   z-index: 1;
`;

StyledPatientEntitlementsDocumentTabsContent.displayName = 'StyledPatientEntitlementsDocumentTabsContent';
